import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Clock, Zap, Users } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    const element = document.getElementById('pricing-checkout') || document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative pt-40 pb-10 md:pt-48 md:pb-20 overflow-hidden bg-gradient-to-br from-navy via-navy-800 to-navy-900" data-id="element-47">
      {/* Background effects */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-gold/10 rounded-full blur-3xl" data-id="element-48" />
      <div className="absolute bottom-10 right-10 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl" data-id="element-49" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60%] h-[60%] bg-gold/[0.04] rounded-full blur-[100px]" data-id="element-50" />

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-51">
        <div className="grid md:grid-cols-2 gap-10 md:gap-12 items-center" data-id="element-52">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center md:items-start text-center md:text-left z-10" data-id="element-53">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-gold/15 text-gold font-heading text-xs sm:text-sm font-semibold mb-6 border border-gold/30" data-id="element-54">
              <span className="relative flex h-2 w-2 flex-shrink-0" data-id="element-55">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-75" data-id="element-56" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-gold" data-id="element-57" />
              </span>
              El sistema probado para latinos con ITIN o SSN
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white leading-[1.15] mb-5" data-id="element-58">
              Cómo Escalar tu Negocio en USA y Obtener{' '}
              <span className="text-gold relative inline-block" data-id="element-59">
                $100k en Crédito
                <svg className="absolute w-full h-3 -bottom-1 left-0 text-gold/30" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-60">
                  <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="4" fill="transparent" data-id="element-61" />
                </svg>
              </span>{' '}
              Comercial Sin Ser Esclavo de la Herramienta
            </h1>

            <p className="text-base sm:text-lg md:text-xl text-gray-300 mb-6 max-w-lg" data-id="element-62">
              Descubre los protocolos exactos para estructurar tu LLC, blindar
              tu patrimonio y acceder a capital bancario masivo, incluso si
              estás empezando.
            </p>

            {/* Urgency bar */}
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4,
            duration: 0.5
          }} className="flex items-center gap-2 mb-6 px-4 py-2 rounded-lg bg-red-500/10 border border-red-500/20" data-id="element-63">
              <Zap className="w-4 h-4 text-red-400 flex-shrink-0" data-id="element-64" />
              <span className="text-red-300 text-sm font-heading font-semibold" data-id="element-65">
                Precio de lanzamiento:{' '}
                <span className="line-through text-gray-500" data-id="element-66">$488</span>{' '}
                <span className="text-gold font-extrabold" data-id="element-67">$6.36</span>
              </span>
            </motion.div>

            {/* CTA */}
            <div className="w-full sm:w-auto flex flex-col items-center sm:items-start gap-3" data-id="element-68">
              <button onClick={scrollToPricing} className="w-full sm:w-auto px-10 py-4 bg-gold hover:bg-gold-dark text-navy font-heading font-bold text-lg rounded-xl transition-all duration-300 shadow-lg shadow-gold/30 hover:shadow-glow transform hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-69">
                <Zap className="w-5 h-5" data-id="element-70" />
                Acceso Inmediato por $6.36
              </button>

              <div className="flex flex-wrap items-center justify-center sm:justify-start gap-x-4 gap-y-1 text-xs sm:text-sm text-gray-400 font-heading" data-id="element-71">
                <span className="flex items-center gap-1" data-id="element-72">
                  <Clock className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gold flex-shrink-0" data-id="element-73" />{' '}
                  Acceso inmediato
                </span>
                <span className="flex items-center gap-1" data-id="element-74">
                  <ShieldCheck className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gold flex-shrink-0" data-id="element-75" />{' '}
                  Garantía 30 días
                </span>
                <span className="flex items-center gap-1" data-id="element-76">
                  <Users className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-gold flex-shrink-0" data-id="element-77" />{' '}
                  +2,400 alumnos
                </span>
              </div>
            </div>
          </motion.div>

          {/* Right - Premium Ebook Visual */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex flex-col items-center relative z-10" data-id="element-78">
            {/* Glow behind device */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-72 h-72 md:w-80 md:h-80 bg-gold/10 rounded-full blur-[80px]" data-id="element-79" />

            {/* iPad / Tablet Mockup */}
            <motion.div animate={{
            y: [0, -8, 0]
          }} transition={{
            repeat: Infinity,
            duration: 5,
            ease: 'easeInOut'
          }} className="relative z-10" data-id="element-80">
              <div className="relative w-60 sm:w-72 md:w-80" data-id="element-81">
                {/* Device shadow */}
                <div className="absolute -bottom-5 left-6 right-6 h-10 bg-black/30 rounded-full blur-2xl" data-id="element-82" />

                {/* Device frame */}
                <div className="relative bg-[#1a1a2e] rounded-[24px] sm:rounded-[28px] p-2.5 sm:p-3 shadow-2xl shadow-black/40 border border-white/[0.08]" data-id="element-83">
                  {/* Camera notch */}
                  <div className="absolute top-[10px] left-1/2 -translate-x-1/2 w-2 h-2 rounded-full bg-white/10 z-20" data-id="element-84" />

                  {/* Screen */}
                  <div className="relative w-full aspect-[3/4] rounded-[16px] sm:rounded-[20px] overflow-hidden bg-gradient-to-br from-navy via-navy-800 to-blue-950" data-id="element-85">
                    {/* Screen shine */}
                    <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/[0.03] to-white/[0.06]" data-id="element-86" />

                    {/* Inner border frame */}
                    <div className="absolute inset-4 sm:inset-5 border border-gold/20 rounded-lg" data-id="element-87" />

                    {/* Corner accents */}
                    <div className="absolute top-4 left-4 sm:top-5 sm:left-5 w-3 h-3 border-t border-l border-gold/40" data-id="element-88" />
                    <div className="absolute top-4 right-4 sm:top-5 sm:right-5 w-3 h-3 border-t border-r border-gold/40" data-id="element-89" />
                    <div className="absolute bottom-4 left-4 sm:bottom-5 sm:left-5 w-3 h-3 border-b border-l border-gold/40" data-id="element-90" />
                    <div className="absolute bottom-4 right-4 sm:bottom-5 sm:right-5 w-3 h-3 border-b border-r border-gold/40" data-id="element-91" />

                    {/* Ebook Content */}
                    <div className="relative z-10 w-full h-full flex flex-col items-center justify-center p-6 sm:p-8" data-id="element-92">
                      <div className="w-8 h-[2px] bg-gold rounded-full mb-4" data-id="element-93" />

                      <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center mb-3 sm:mb-4" data-id="element-94">
                        <span className="text-gold text-base sm:text-lg" data-id="element-95">
                          👑
                        </span>
                      </div>

                      <h3 className="text-white font-heading font-extrabold text-xl sm:text-2xl md:text-3xl leading-none tracking-tight" data-id="element-96">
                        IMPERIO
                      </h3>
                      <h3 className="text-gold font-heading font-extrabold text-xl sm:text-2xl md:text-3xl leading-none tracking-tight" data-id="element-97">
                        AMERICANO
                      </h3>

                      <div className="w-12 h-[1px] bg-gradient-to-r from-transparent via-gold/50 to-transparent my-3 sm:my-4" data-id="element-98" />

                      <p className="text-gray-300 text-[10px] sm:text-xs uppercase tracking-[0.25em] font-heading" data-id="element-99">
                        Guía Completa 2026
                      </p>
                      <p className="text-gray-500 text-[9px] sm:text-[10px] uppercase tracking-[0.2em] mt-1 font-heading" data-id="element-100">
                        Escala tu Negocio en USA
                      </p>

                      <div className="mt-auto pt-3 sm:pt-4 flex items-center gap-2" data-id="element-101">
                        <div className="w-1.5 h-1.5 rounded-full bg-gold/30" data-id="element-102" />
                        <div className="w-5 h-[1px] bg-gold/30" data-id="element-103" />
                        <div className="w-1.5 h-1.5 rounded-full bg-gold/30" data-id="element-104" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Feature badges — clean inline cards */}
            <motion.div initial={{
            opacity: 0,
            y: 15
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.8,
            duration: 0.5
          }} className="flex gap-3 mt-3 relative z-10" data-id="element-105">
              <div className="flex items-center gap-2 bg-navy-800/80 backdrop-blur-md border border-green-500/25 rounded-lg px-3 py-2 shadow-lg" data-id="element-106">
                <div className="w-7 h-7 rounded-full bg-green-500/15 border border-green-500/25 flex items-center justify-center" data-id="element-107">
                  <ShieldCheck className="w-3.5 h-3.5 text-green-400" data-id="element-108" />
                </div>
                <div data-id="element-109">
                  <p className="text-white text-xs font-heading font-bold leading-tight" data-id="element-110">
                    LLC Blindada
                  </p>
                  <p className="text-green-400/70 text-[10px] font-heading" data-id="element-111">
                    Protección total
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-2 bg-navy-800/80 backdrop-blur-md border border-gold/25 rounded-lg px-3 py-2 shadow-lg" data-id="element-112">
                <div className="w-7 h-7 rounded-full bg-gold/15 border border-gold/25 flex items-center justify-center" data-id="element-113">
                  <span className="text-gold text-xs" data-id="element-114">💳</span>
                </div>
                <div data-id="element-115">
                  <p className="text-white text-xs font-heading font-bold leading-tight" data-id="element-116">
                    Crédito $100k+
                  </p>
                  <p className="text-gold/70 text-[10px] font-heading" data-id="element-117">
                    Sin garantía personal
                  </p>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}